import { defineNuxtPlugin, useRuntimeConfig } from '#imports'
import { getAuthConfigFor, provideAuthService, contexts } from '@b2ag/auth'
import { getAppContext } from '@b2ag/micro-front-tools'

async function initAuthService() {
  const extraConfig: any = {}
  const { appFrontType } = getAppContext()
  const config = useRuntimeConfig()

  switch (appFrontType) {
    case 'agri':
      extraConfig.extranetConnection = config.public.AUTH0_EXTRANET_CONNECTION
      break
    case 'tech':
      extraConfig.smagConnection = config.public.AUTH0_SMAG_CONNECTION
      break
    default:
      break
  }

  const context = import.meta.server ? contexts.SERVER_SIDE : contexts.DEFAULT

  await provideAuthService(
    {
      audience: config.public.AUTH0_AUDIENCE!,
      domain: config.public.AUTH0_DOMAIN!,
      redirectUri: `${config.public.FRONT_URL}/oauth/callback`,
      authority: config.public.AUTH0_DOMAIN!,
      clientId: config.public.AUTH0_CLIENT_ID!,
      requiredScopes: getAuthConfigFor(appFrontType as 'agri' | 'tech'),
      ...extraConfig,
    },
    {
      name: context,
    },
  )
}

export default defineNuxtPlugin({
  name: 'auth service',
  enforce: 'pre',
  async setup() {
    await initAuthService()
  },
})
